import { formatarDiaMes, formatarDuracaoMinutos } from '@/helpers/formatacao.helpers';
import type { IncidenteHistorico } from '@/types/status.types';

type HistoricoIncidentesProps = {
  historico: IncidenteHistorico[];
  janelaDias: number;
};

const ROTULO_ESTADO: Record<IncidenteHistorico['estado'], { texto: string; cor: string }> = {
  resolvido: { texto: 'Resolvido', cor: 'var(--success-active)' },
  concluida: { texto: 'Concluída', cor: 'var(--info-active)' },
};

export const HistoricoIncidentes = ({ historico, janelaDias }: HistoricoIncidentesProps) => {
  return (
    <section className="cartao-status" id="historico" aria-labelledby="titulo-historico">
      <div className="flex items-baseline justify-between gap-3">
        <h2 id="titulo-historico" className="m-0 text-[15px] font-semibold tracking-[-0.01em]">
          Histórico de incidentes
        </h2>
        <span className="text-[12px] text-muted-foreground">Últimos {janelaDias} dias</span>
      </div>

      {historico.length === 0 ? (
        <p className="mt-4 mb-0 text-[14px] text-muted-foreground">
          Nenhum incidente registrado nos últimos {janelaDias} dias.
        </p>
      ) : (
        <ul className="list-none p-0">
          {historico.map((incidente) => {
            const rotulo = ROTULO_ESTADO[incidente.estado];

            return (
              <li key={incidente.id} className="border-t border-border py-[15px]">
                <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
                  <span className="w-[52px] flex-none text-[12px] text-muted-foreground">
                    <time dateTime={incidente.iniciado_em}>
                      {formatarDiaMes(incidente.iniciado_em)}
                    </time>
                  </span>
                  <span className="min-w-[200px] flex-1 text-[14px] font-medium text-pretty">
                    {incidente.titulo}
                  </span>
                  <span className="text-[12px] text-muted-foreground">
                    {formatarDuracaoMinutos(incidente.duracao_minutos)}
                  </span>
                  <span
                    className="text-[12px] font-semibold whitespace-nowrap"
                    style={{ color: rotulo.cor }}
                  >
                    {rotulo.texto}
                  </span>
                </div>
                {incidente.resumo && (
                  <p className="mt-1.5 mb-0 text-[13px] leading-[1.55] text-pretty text-muted-foreground sm:pl-16">
                    {incidente.resumo}
                  </p>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};
